export default __webpack_public_path__ + "static/media/pdmPreview.e47ead98.jpg";